var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
const STRIP_SYMBOLS_FROM_PHONE = /[-().\s]/gi;
export const fetchPhoneCodeList = (setPhoneCodeList) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const phoneCodes = yield fetch('https://www.paypalobjects.com/iwc/phoneCodeList.json');
        if (phoneCodes.ok) {
            phoneCodes.json().then((data) => {
                setPhoneCodeList(data.map((el) => (React.createElement("option", { key: el[0], value: el[0] + ' +' + el[2] }, el[1] + ' +' + el[2]))));
            });
        }
    }
    catch (e) {
        console.log(e);
    }
});
export const getStrippedPhoneNumber = (number, countryCode) => {
    const INVALID_PHONE = /[^\d]+/g;
    // strip off all special characters that can be used in a phone number
    // such as . ( ) +  - and spaces
    number = number.replace(STRIP_SYMBOLS_FROM_PHONE, '');
    // If phone start with the country code, strip that from number
    const doesNumberStartWithCountryCode = number.lastIndexOf(countryCode, 0) === 0;
    if (doesNumberStartWithCountryCode) {
        number = number.substr(countryCode.length);
    }
    if (!number || number.match(INVALID_PHONE)) {
        return false;
    }
    return number;
};
export const looksLikeAnEmail = (value) => {
    if (!value) {
        // It's true for empty values.
        return true;
    }
    // Remove all special phone chars: -().+ and a space. All of those are used in the NATIONAL phone format below:
    // https://engineering.paypalcorp.com/i18napp/#phone
    value = value.replace(/[-()\.\+\s]/gi, '');
    // If there is no string left after removing special phone characters or
    // if there is any non-digit character after removing phone specific characters, then it looks like email.
    return !value || value.search(/\D+/g) >= 0;
};
